import Axios from "./axios";

const endpoint = "/api/complete";
export default {
  /**
   * 입고 완료 처리
   * @param {Number} invoiceId 출고 Id
   * @param {list} rebarId 자재 id list
   * @param {list} rebarIdValue list 형태 배열
   * @param {Text} selectDate date
   * @returns
   */
  completeCreate: (data) => Axios.post(`${endpoint}/create`, data),

  /**
   * 입고 디테일
   * @param {Number} invoiceId 출고 Id
   * @returns
   */
  completeTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),

  /**
   * 입고 업데이트
   * @param {Number} completeId 입고 Id
   * @param {Json} rebarListData key : rebarName ,rebarValue
   * @param {Text} selectDate 입고일자
   * @returns
   */
  completeUpdate: (data) => Axios.post(`${endpoint}/update`, data),

  /**
   * 입고 삭제
   * @param {Number} completeId 입고 Id
   */
  completeDelete: (data) => Axios.post(`${endpoint}/delete`, data),

  /**
   * 입고 상세
   * @param {Number} completeId 입고 Id
   */
  completeDetail: (data) => Axios.post(`${endpoint}/complete-detail`, data),

  /**
   * 입고 메모 조회
   * @param {Number} completeId 입고 ID
   * @returns
   */
  completeReadMemo: (data) => Axios.post(`${endpoint}/read-memo`, data),

  /**
   * 입고 메모 입력
   * @param {Number} completeId 입고 ID
   * @param {Text} memo 메모
   * @returns
   */
  completeWriteMemo: (data) => Axios.post(`${endpoint}/write-memo`, data),

  /**
   * 입고 등록 출고 리스트
   * @param {Number} constructionId 현장 ID
   * @returns
   */
  completeInvoiceList: (data) => Axios.post(`${endpoint}/invoice-list`, data),

  /**
   * 필터 리스트 조회
   * @param {Number} constructionId 현장번호
   * @returns
   */
  completeFilterListSearch: (data) =>
    Axios.post(`${endpoint}/search-list`, data),
};
